import React, { useContext, useEffect, useState, useRef } from 'react';

import { ThemeContext } from '../../../context/ThemeContext';
import MainPagetitle from '../../layouts/PredictionsPagetitle';
import GoalsView from '../bootstrap/GoalsView'; 
import FooterBar from './FooterBar';
import { useSelector } from 'react-redux';
import bg6 from '../../../images/background/nye-slim-2600.png';

const Home = () => {
  const currentUser = useSelector((state) => state.user.currentUser);
	const task = useRef();
  const { changeBackground } = useContext(ThemeContext);
  const [activeTab, setActiveTab] = useState('Goals'); // Initialize with the default tab

  useEffect(() => {
    changeBackground({ value: 'light', label: 'Light' });
  }, []);

  return (
    /* <div style={{ background: `#fff url(${bg6}) center center / cover no-repeat`, height: "100vh" }}> */
    <div>
    <div className="container-fluid" style={{ height: '440px', backgroundColor: "#01152F"}}>
      <MainPagetitle mainTitle="Goals" pageTitle="Goals" parentTitle="Home" />
      <div className="container-fluid" style={{ backgroundColor: "#01152F" }}>
        <div className="row" style={{ backgroundColor: "#01152F" }}>
          <div className="col-xl-12 wid-100" style={{ backgroundColor: "#01152F" }}>
			      <GoalsView />
          </div>
        </div>		
        <div className="row" style={{ backgroundColor: "#01152F" }}>
          <div className="col-xl-12 mt-3">
            {" "}
          </div>
        </div>	
        <div className="row">
          <div className="col-xl-12 mt-3">
            {" "}
          </div>
       </div>
      </div>
      <FooterBar activeTab={activeTab} currentUser={currentUser} /> {/* Pass activeTab as a prop */}
      </div>
    </div>
  );
};

export default Home;
 